import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GlobalService } from '../global.service';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.sass']
})
export class SplashComponent implements OnInit {
  public show:boolean=true;
  @Input() optionTemplete:string;
  @Input() contentSplash:any;
  @Input() account:any;
  @Input() id:any;
  update: Subscription;
  constructor(private services: Service,private router: Router,public global:GlobalService,private loadingScreenService :LoadingScreenService) { }

  ngOnInit(): void {
    console.log(this.contentSplash)
    this.update = this.global.updateSplash.subscribe((value:boolean) => {
      this.show=true;  
    });
  }
  close(){
    if(this.optionTemplete=='templete'){
      this.services.updMessageStatus(this.account,sessionStorage.getItem("token"),this.id).subscribe(data =>{
        if(data.hasError ==false){
          this.loadingScreenService.stopLoading();
          this.show=false;
          this.global.splashActive=false;
          if(data.ErrorDesc!=''&&data.ErrorDesc!=undefined&&data.ErrorDesc!=null){
            this.global.notif(data.ErrorDesc);
          }
        }
        else{
          this.loadingScreenService.stopLoading();
          this.global.notif(data.ErrorDesc);
        }
      });
    }
    else{
      this.show=false;
      this.global.splashActive=false;
    }
  }
  goTo(){
    this.router.navigate(['/iptv/1']);
    // this.global.goStore()
  }
  ngOnDestroy() {
    if(this.update){
      this.update.unsubscribe();
    }
  }
}
